// ################################################################################################################
// Nota: Los elementos de un componente tiene prioridad a los de los mixin que pueda poseer.
// ################################################################################################################

// Notificaciones:
import { useToast } from 'vue-toastification';

// EXPORT
export const GlobalMixin = {
  data: {
    productVersion: '1.2.0',
  },
  methods: {
    // ######################################################################################
    // ##################################### VUE-SELECT #####################################
    // ######################################################################################
    filterOptions(options, search, fields = [], normalizeFn) {
      if (!search) return options;

      const normalize =
        normalizeFn ||
        ((input) => {
          if (!input) return '';
          return String(input)
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[.\-]/g, '')
            .toLowerCase()
            .trim();
        });
      const term = normalize(search);

      return options.filter((option) => {
        return fields.some((field) => {
          let value;
          if (typeof field === 'function') {
            value = field(option);
          } else {
            value = option[field];
          }
          return normalize(value).includes(term);
        });
      });
    },
    // ######################################################################################
    // ################################### RESPONSIVIDAD ####################################
    // ######################################################################################
    handleResize(variable, width) {
      this[variable] = window.innerWidth <= width;
    },
    // ######################################################################################
    // ################################### TOASTIFICATION ###################################
    // ######################################################################################
    toast(type, message) {
      useToast()[type](message, {
        position: 'top-right',
        timeout: 3000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.5,
        showCloseButtonOnHover: true,
        hideProgressBar: true,
        closeButton: 'button',
        icon: true,
        rtl: false,
      });
    },
    // ######################################################################################
    // ######################################################################################
    // ######################################################################################
  },
};
